export const customFields = {
  FETCH_CUSTOM_FIELDS: `accounts/register-fields/{tenantUuid}?rnd=${Math.random() * 15}`,
  ADD_CUSTOM_FIELD: 'accounts/register-field',
  CUSTOM_FIELD: 'accounts/register-field/{id}',
};
